var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.$func.storyblok2Css(_vm.blok)},[_c('h5',[_vm._v(_vm._s(_vm.blok.subheading))])])}
var staticRenderFns = []

export { render, staticRenderFns }